import Vue from 'vue';
import Nav from '@/components/Nav.vue';
import InputField from '@/components/InputField.vue';
import SelfHelpTools from '@/components/SelfHelpTools.vue';
import IssueBar from '@/components/IssueBar.vue';
import ChatContent from '@/components/ChatContent.vue';


Vue.component('zdy-nav', Nav);
Vue.component('input-field', InputField);
Vue.component('self-help-tools', SelfHelpTools);
Vue.component('issue-bar', IssueBar);
Vue.component('chat-content', ChatContent);

